import {useState, useEffect, Fragment} from 'react'
import Api from '../../../../../thesis-and-dissertations/helpers/api'
import PaginationLayout from './PaginationLayout'
import {useNavigate} from 'react-router-dom'
import InformationLayout from './Information'
import TabStatusLayout from './TabStatusLayout'
import LawModal from './LawModal'
import LetterModal from './LetterModal'
import NumberCircle from './NumberCircle'
import BadgeCategory from './BadgeCategory'
import handleApiError from 'thesis-and-dissertations/helpers/handleApiError'
import Pagination from 'react-bootstrap/Pagination'
import usePagination from 'utils/hooks/usePagination'
import {clearLocalStorageExcept, getGreeting} from 'thesis-and-dissertations/helpers/helper'
import {toast} from 'react-toastify'
import './style.css'
import SortableHeaders from '../Reviewer/SortableHeaders'

const api = new Api()

const VerifierHomePage = () => {
  let navigate = useNavigate()
  const [pagination, setPagination] = useState({
    per_page: 10,
    page: 1,
    total_page: 1,
    total_page_arr: [1, 2, 3, 4, 5],
    total_row: 10,
  })

  const [showLetterModal, setShowLetterModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [asAgree, setAsAgree] = useState(false)
  const [query, setQuery] = useState<any>({q: '', sort_order: 'desc', role: 'proposal'})

  const [data, setData] = useState<any>({})
  const [user, setUser] = useState<any>({})
  const [currentLetter, setCurrentLetter] = useState({title: '', buttonText: ''})
  const [buttonExtra, setButtonExtra] = useState<any>([
    {
      name: 'Export Excel',
      color: '#F95E2F',
      key: 'Export Excel',
      icon: 'fa fa-file-excel',
    },
  ])

  const [sorting, setSorting] = useState({
    sort_field: '',
    sort_order: '', // 'asc' atau 'desc'
  })

  const paginator: any = usePagination({
    totalCount: data?.list?.total || 0,
    pageSize: pagination.per_page || 10,
    currentPage: pagination.page || 1,
  })

  useEffect(() => {
    fetchIntegrityFacts()
    setUser(JSON.parse(localStorage?.getItem('kt-auth-react-v') || ''))
  }, [])

  useEffect(() => {
    setQuery({
      ...query,
      sort_field: sorting.sort_field,
      sort_order: sorting.sort_order,
    })
  }, [sorting])

  useEffect(() => {
    fetchData()
  }, [query, pagination.per_page, pagination.page])

  const onChangePerPage = (data: any) => {
    setPagination(data)
  }

  const handleCloseModal = (action: boolean) => {
    setAsAgree(action)
    if (action === false) {
      setShowLetterModal(true)
      handleCurrentLetter('Pakta Integritas', 'Saya Setuju', true)
    }
  }

  const handleCloseLetterModal = (action: boolean) => {
    setAsAgree(action)
    handleCurrentLetter('', '', false)

    fetchData()
  }

  // Helper untuk status
  const isSignedOrNeedSign = (status?: string) => status === 'need_sign' || status === 'signed'

  const isNeedSign = (status?: string) => status === 'need_sign'

  const fetchData = () => {
    setLoading(true)
    api
      .getListRegistrationPana({
        ...query,
        page: pagination.page,
        per_page: pagination.per_page,
      })
      .then((response: any) => {
        const {data} = response.data
        setData(data)
        setLoading(false)

        // Ambil status dari data
        const baProposalStatus = data?.ba_proposal_status
        const baWawancaraStatus = data?.ba_wawancara_status

        // Siapkan tombol
        const proposalBtn = isSignedOrNeedSign(baProposalStatus)
          ? {
              name: `${isNeedSign(baProposalStatus) ? 'TTD' : 'Lihat'} BA Proposal`,
              color: '#5C5ACA',
              key: 'BA PROPOSAL',
              icon: 'fa fa-signature',
            }
          : null

        const substansiBtn = isSignedOrNeedSign(baWawancaraStatus)
          ? {
              name: `${isNeedSign(baWawancaraStatus) ? 'TTD' : 'Lihat'} BA Substansi`,
              color: '#5C5ACA',
              key: 'BA SUBSTANSI',
              icon: 'fa fa-signature',
            }
          : null
        // Ambil hanya tombol yang tidak null
        const buttonExtras = [proposalBtn, substansiBtn].filter(Boolean)

        // Buat Map agar mudah override berdasarkan key
        const buttonMap = new Map()

        // Masukkan tombol existing dulu
        buttonExtra.forEach((btn: any) => {
          buttonMap.set(btn.key, btn)
        })

        // Override dengan tombol baru (jika key sama, akan diganti)
        buttonExtras.forEach((btn: any) => {
          buttonMap.set(btn.key, btn)
        })

        // Ubah kembali ke array
        const combined = Array.from(buttonMap.values())

        setButtonExtra(combined)

        // Panggil handleCurrentLetter sesuai status
        if (isNeedSign(baProposalStatus)) {
          handleCurrentLetter(
            'BA PROPOSAL',
            isNeedSign(baProposalStatus) ? 'SAYA MENYETUJUI KETENTUAN DI ATAS' : '',
            isNeedSign(baProposalStatus)
          )
          return
        }

        if (isNeedSign(baWawancaraStatus)) {
          handleCurrentLetter(
            'BA SUBSTANSI',
            isNeedSign(baWawancaraStatus) ? 'SAYA MENYETUJUI KETENTUAN DI ATAS' : '',
            isNeedSign(baWawancaraStatus)
          )
        }
      })
      .catch((error: any) => {
        setLoading(false)
        const {data, status} = error?.response
        toast.error(data?.message ?? data?.meta?.message)

        if (status == 401) {
          clearLocalStorageExcept()
          window.location.reload()
        }
      })
  }

  const fetchIntegrityFacts = () => {
    setLoading(true)
    api
      .getIntegrityFacts()
      .then((response: any) => {
        const {data} = response.data
        setAsAgree(data?.status === false ? true : false)
        setLoading(false)
      })
      .catch((error: any) => {
        setLoading(false)
      })
  }

  const zoomLink = (item: any) => {
    if (data?.proposal_only === true) return null

    return (
      item?.link_zoom_wawancara_1 ||
      item?.link_zoom_wawancara_2 ||
      item?.link_zoom_wawancara_3 ||
      null
    )
  }

  const handleCurrentLetter = (letter: string, buttonText: string, isShow: boolean) => {
    setCurrentLetter({
      title: letter,
      buttonText: buttonText,
    })

    setShowLetterModal(isShow)
  }

  const handleSorting = (sort_field: any) => {
    setSorting((prev) => {
      const isSameKey = prev.sort_field === sort_field
      const newOrder = isSameKey && prev.sort_order === 'asc' ? 'desc' : 'asc'
      return {sort_field, sort_order: newOrder}
    })
  }

  const handleCurrentTab = (status: any) => {
    setQuery({status_tab: status})

    setPagination({
      ...pagination,
      per_page: 10,
      page: 1,
    })
  }

  const handleInput = (name: string, e: any) => {
    setQuery({...query, [name]: e?.target?.value ?? e})
    setPagination({...pagination, per_page: pagination.per_page, page: 1})
  }

  return (
    <div>
      <LawModal showModal={asAgree} handleCloseModal={handleCloseModal} />
      <LetterModal
        showLetterModal={showLetterModal}
        handleCloseLetterModal={handleCloseLetterModal}
        currentLetter={currentLetter}
        currentPage='substansi'
      />

      <div style={{marginTop: '-15px'}}>
        <p className='display-6 fw-normal'>
          {getGreeting()}, {user?.users_firstname}
        </p>
        <p>Berikut adalah daftar peserta yang perlu dinilai hari ini</p>
      </div>

      <InformationLayout />

      <TabStatusLayout
        data={[
          {
            name: 'Semua',
            key: '',
            value: data?.count?.total_pendaftaran,
          },
          {
            name: 'Belum Penilaian Proposal',
            key: 'belum_penilaian_proposal',
            value: data?.count?.belum_penilaian_proposal,
          },
          {
            name: 'Sudah Penilaian Proposal',
            key: 'sudah_penilaian_proposal',
            value: data?.count?.sudah_penilaian_proposal,
          },
          {
            name: 'Belum Penilaian Wawancara',
            key: 'belum_penilaian_reviewer',
            value: data?.count?.belum_penilaian_reviewer,
          },
          {
            name: 'Sudah Penilaian Wawancara',
            key: 'sudah_penilaian_reviewer',
            value: data?.count?.sudah_penilaian_reviewer,
          },
        ]}
        currentLetter={currentLetter}
        handleCurrentLetter={handleCurrentLetter}
        handleCurrentTab={handleCurrentTab}
        buttons={buttonExtra}
        disabledTab={false}
      />

      <div className='mt-4'>
        <div className='table-responsive'>
          <table className='table table-borderless align-middle'>
            <thead className='bg-white'>
              <tr>
                <th className='bg-light'>
                  <input
                    type='text'
                    className='form-control'
                    placeholder='Cari Nama'
                    onChange={(e) => handleInput('q', e)}
                  />
                </th>

                <th className='bg-light'>
                  <select className='form-control' onChange={(e) => handleInput('kategori', e)}>
                    <option value=''>--Pilih Kategori--</option>
                    <option value='individu'>Individu</option>
                    <option value='kelompok'>Kelompok</option>
                  </select>
                </th>
              </tr>
              <tr>
                <SortableHeaders
                  label='NAMA'
                  field='nama_pendaftar'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <SortableHeaders
                  label='KATEGORI'
                  field='kategori'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <SortableHeaders
                  label='WAKTU PENDAFTARAN'
                  field='waktu_pendaftaran'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <SortableHeaders
                  label='NILAI PROPOSAL'
                  field='nilai_proposal'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <SortableHeaders
                  label='NILAI WAWANCARA'
                  field='nilai_wawancara'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <SortableHeaders
                  label='TANGGAL WAWANCARA'
                  field='waktu_zoom'
                  handleSorting={handleSorting}
                  sorting={sorting}
                />

                <th className='py-5'>AKSI</th>
              </tr>
            </thead>
            <tbody>
              {data?.list?.data?.length > 0 ? (
                data?.list?.data.map((item: any, index: number) => (
                  <Fragment key={item.id || index}>
                    <tr>
                      <td colSpan={6} style={{height: '16px', backgroundColor: 'transparent'}}></td>
                    </tr>
                    <tr className='bg-white'>
                      <td style={{borderTopLeftRadius: '20px', borderBottomLeftRadius: '20px'}}>
                        <div className='d-flex align-items-center p-5'>
                          <div
                            className='rounded-circle bg-secondary d-flex justify-content-center align-items-center'
                            style={{width: '40px', height: '40px'}}
                          >
                            <i className='fa fa-user'></i>
                          </div>
                          <div className='ms-3'>
                            <div className='fw-semibold'>{item?.nama_pendaftar}</div>
                            <div className='text-muted' style={{fontSize: '0.85rem'}}>
                              {item?.no_registrasi_pendaftaran}
                            </div>
                          </div>
                        </div>
                      </td>
                      <td>
                        <BadgeCategory
                          text={item?.kategori === 'kelompok' ? 'Kelompok' : 'Individu'}
                          textColor={item?.kategori === 'kelompok' ? '#1E40AF' : '#1E40AF'}
                          bgColor={item?.kategori === 'kelompok' ? '#DBEAFE' : '#FFDFFF'}
                        />
                      </td>
                      <td>{item?.waktu_pendaftaran}</td>
                      <td>
                        <NumberCircle value={item?.nilai_proposal ?? 0} />
                      </td>
                      <td>
                        <NumberCircle value={item?.nilai_wawancara ?? 0} />
                      </td>
                      <td>{item?.waktu_zoom ?? '-'}</td>
                      <td style={{borderTopRightRadius: '20px', borderBottomRightRadius: '20px'}}>
                        <div className='d-flex align-items-center'>
                          {zoomLink(item) && (
                            <button
                              className='btn btn-blue btn-sm text-white me-2'
                              onClick={() => window.open(zoomLink(item), '_blank')}
                            >
                              <i className='fas fa-video me-1 text-white'></i>JOIN ZOOM
                            </button>
                          )}
                          {item?.is_proposal_1_assigned == 1 && (
                            <button
                              onClick={() =>
                                navigate(`/proposal/${item?.id_assignment_proposal_1}`)
                              }
                              className='btn btn-sm text-white px-3 btn-primary me-2'
                            >
                              <i className='fa fa-file me-1'></i>PROPOSAL 1
                            </button>
                          )}

                          {item?.is_proposal_2_assigned == 1 && (
                            <button
                              onClick={() =>
                                navigate(`/proposal/${item?.id_assignment_proposal_2}`)
                              }
                              className='btn btn-sm text-white px-3 btn-primary me-2'
                            >
                              <i className='fa fa-file me-1'></i>PROPOSAL 2
                            </button>
                          )}

                          {item?.is_wawancara_1_assigned == 1 && (
                            <button
                              onClick={() =>
                                navigate(`/wawancara/${item?.id_assignment_wawancara_1}`)
                              }
                              className='btn btn-sm text-white px-3 btn-primary'
                            >
                              <i className='fas fa-comments me-1'></i>WAWANCARA 1
                            </button>
                          )}

                          {item?.is_wawancara_2_assigned == 1 && (
                            <button
                              onClick={() =>
                                navigate(`/wawancara/${item?.id_assignment_wawancara_2}`)
                              }
                              className='btn btn-sm text-white px-3 btn-primary'
                            >
                              <i className='fas fa-comments me-1'></i>WAWANCARA 2
                            </button>
                          )}

                          {item?.is_wawancara_3_assigned == 1 && (
                            <button
                              onClick={() =>
                                navigate(`/wawancara/${item?.id_assignment_wawancara_3}`)
                              }
                              className='btn btn-sm text-white px-3 btn-primary'
                            >
                              <i className='fas fa-comments me-1'></i>WAWANCARA 3
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  </Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={6} className='text-center py-5'>
                    <div className='text-muted'>
                      <i className='fa fa-folder-open fa-2x mb-2'></i>
                      <div>Tidak ada data</div>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
      <div className='px-1'>
        <PaginationLayout
          paginate={pagination}
          paginator={paginator}
          onChangePerPage={onChangePerPage}
          totalData={data?.list?.data?.length}
        />
      </div>
    </div>
  )
}

const VerifierHome = () => {
  return (
    <>
      <VerifierHomePage />
    </>
  )
}

export default VerifierHome
